class InitiativeAddition {
    init() {
        if ($("#page-circles").length) {
            this.initNavigation();
        }

        this.initLinkElement();
    }

    initNavigation() {
        $("#page-circles a, .section-header a").on("click", event => {
            event.preventDefault();
            $("form").attr("action", $(event.currentTarget).attr("href")).submit();
        });
    }

    initLinkElement() {
        this.$elementContainer = $("#links-element");

        if (!this.$elementContainer.length) {
            return;
        }

        this.$input = this.$elementContainer.find("input");

        let documentUrl = this.$elementContainer.attr("data-get-document-url");

        let $inputGroup = $('<div class="input-group">');
        let $addButton = $('<div class="input-group-append">\n' +
        '<button class="btn btn-add btn-outline-secondary" type="button">\n' +
        '<i class="fas fa-plus"> </i>\n' +
        '</button>\n' +
        '</div>');

        let $inputParent = this.$input.parent();
        $inputGroup.append(this.$input);
        $inputGroup.append($addButton);
        $inputParent.append($inputGroup);

        $(document).on("click", ".btn-add", (event) => {
            let $button = $(event.currentTarget);
            let $inputGroup = $button.closest(".input-group");

            let $newInputGroup = $inputGroup.clone();
            $newInputGroup.find("input").val("");

            $inputGroup.after($newInputGroup);

            $(".input-group").not($newInputGroup).each((index, element) => {
                $(element).find(".fa-plus").removeClass("fa-plus").addClass("fa-minus");
                $(element).find(".btn-add").removeClass("btn-add").addClass("btn-delete");
            });
        });

        $(document).on("click", ".btn-delete", (event) => {
            $(event.currentTarget).closest(".input-group").remove();
        });

        $(document).on("focusout", 'input[name="links[]"]', (event) => {
            let $input = $(event.currentTarget);
            let value = $input.val();

            if (!value) {
                return;
            }

            if (!/^https?:\/\//i.test(value)) {
                value = 'http://' + value;
                $input.val(value);
            }
        });

        // Restore links
        let links = JSON.parse(this.$elementContainer.attr("data-links"));

        if (Array.isArray(links) && links.length > 0) {
            links.forEach((link) => {
                let $inputGroup = this.$elementContainer.find(".input-group").last();
                $inputGroup.find("input").val(link[0]);
                $inputGroup.find(".btn-add").trigger("click");
                $inputGroup.after('<a target="_blank" href="' + documentUrl.replace('?', link[1]) + '">' +
                    'HTML Datei ansehen ('+link[2]+')' +
                    '</a><br><br>');
            });
        }

        // Add error message
        if (this.$input.hasClass("is-invalid")) {
            this.$elementContainer.find(".invalid-feedback").show();
        }
    }
}

export default InitiativeAddition;